module.exports = __webpack_public_path__ + "static/media/linkedIn_referral_Icon.c07a55db.svg";